var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMoney = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25.063a6.256 6.256 0 01-6.25-6.25c0-3.448 2.803-6.25 6.25-6.25s6.25 2.802 6.25 6.25a1.562 1.562 0 11-3.125-.001c0-1.722-1.402-3.125-3.125-3.125s-3.125 1.403-3.125 3.126a3.13 3.13 0 003.125 3.125 1.562 1.562 0 110 3.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 34.438a6.256 6.256 0 01-6.25-6.25 1.563 1.563 0 113.125 0c0 1.722 1.402 3.125 3.125 3.125s3.125-1.403 3.125-3.125a3.129 3.129 0 00-3.125-3.125 1.563 1.563 0 010-3.126 6.256 6.256 0 016.25 6.25 6.255 6.255 0 01-6.25 6.25zm0-18.75c-.863 0-1.563-.7-1.563-1.563V9.437a1.562 1.562 0 113.126.001v4.687c0 .863-.7 1.563-1.563 1.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 39.125c-.863 0-1.563-.7-1.563-1.563v-4.687a1.563 1.563 0 013.126 0v4.688c0 .863-.7 1.562-1.563 1.562z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 46.938C10.576 46.938.062 36.424.062 23.5S10.576.062 23.5.062 46.938 10.576 46.938 23.5 36.424 46.938 23.5 46.938zm0-43.75C12.301 3.188 3.187 12.3 3.187 23.5c0 11.199 9.114 20.313 20.313 20.313 11.199 0 20.313-9.114 20.313-20.313 0-11.199-9.114-20.313-20.313-20.313z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoney, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/money.a55f16d6.svg";
export { ForwardRef as ReactComponent };